export default __webpack_public_path__ + "static/ruby-1f6d8959334238cf022a2549ef5db72e.svg";